/* The wishlist drawer and the hearts (markup and styles: snippets/wishlist.liquid).
   Was inline in every page (37 KB parsed before the page could finish); now one cached file,
   run once the page has been read. */
(function () {
  if (window.__kkWishlist) return;
  var KEY = 'kk_wishlist';
  var root = document.querySelector('[data-wl]');
  if (!root) return;
  var body = root.querySelector('[data-wl-body]');
  var foot = root.querySelector('[data-wl-foot]');
  var lastFocus = null;
  var tab = 'saved';                     // 'saved' | 'rewards'
  var rewardsEl = root.querySelector('[data-wl-rewards]');
  function pick(name) { return name === 'rewards' && rewardsEl ? 'rewards' : 'saved'; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var statusEl = root.querySelector('[data-wl-status]');
  function announce(text) { if (statusEl) { statusEl.textContent = ''; setTimeout(function () { statusEl.textContent = text; }, 30); } }
  var closing = 0;      // the close in progress: opening again before it ends cancels it
  var autoOpen = 0;     // the product page heart's open, a moment after it fills

  // the Recently viewed list is gone (2026-10-02): its record in the browser goes too
  try { localStorage.removeItem('kk_recent'); } catch (e) {}

  /* ---------- storage ---------- */
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (i) { return i && i.handle; }) : [];
    } catch (e) { return []; }        // private mode / corrupt value: behave as empty
  }
  function store(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    paintCount(); paintHearts();
  }
  // every change the shopper makes: kept here, and sent to their account when signed in
  function write(list) { store(list); changed(); }

  /* ---------- the list on the customer's account: the same on every device ----------
     Signed in, the page carries the account's copy (custom.wishlist, read by Liquid: {t, items},
     t being when the Worker wrote it) and the customer's id signed by Liquid. Each change is
     sent to the rewards Worker (/wishlist, integrations/kaarkash-wishlist.mjs) a moment after
     the last, one send at a time, with the copy it was made from (base); a send waiting as the
     page is left goes at once. A mark in the browser (kk_wishlist_sync: {c: customer, d:
     changes not on the account yet, t and b: the account copy this device's list was made
     from}) says how the two stand when a page opens:
     - nothing written from elsewhere since this device's copy: the list here stands (and goes,
       if it has changes);
     - written from another device since: the account's copy is the list, with this device's
       own changes (pieces added or taken off since its copy) put on top of it;
     - first time here signed in: the account's list, with what was saved here as a guest;
     - another customer's list was last here: it is not carried over.
     Signing out takes the list off the device (it is kept on the account): whoever uses it
     next does not see it. The Worker refuses a send made from an older copy than the
     account's (409, with that copy), and the page puts the two together the same way. */
  var SYNC_KEY = 'kk_wishlist_sync';
  var MAX_ITEMS = 100;                 // as the Worker keeps (integrations/kaarkash-wishlist.mjs)
  var syncUrl = root.getAttribute('data-wl-sync') || '';
  var who = null;
  try { who = JSON.parse(root.getAttribute('data-wl-who') || 'null'); } catch (e) { who = null; }
  if (!who || !who.id || !syncUrl) who = null;
  var syncTimer = 0, sending = false, conflicts = 0;
  function syncMark() { try { return JSON.parse(localStorage.getItem(SYNC_KEY) || 'null') || {}; } catch (e) { return {}; } }
  function setSyncMark(m) { try { localStorage.setItem(SYNC_KEY, JSON.stringify(m)); } catch (e) {} }
  function sameList(a, b) { return JSON.stringify(a) === JSON.stringify(b); }
  function pieces(list) { return Array.isArray(list) ? list.filter(function (i) { return i && i.handle; }) : []; }
  function find(list, handle) { return list.filter(function (x) { return x.handle === handle; })[0]; }
  // theirs, with what this device changed since base on top: its additions, its removals, a
  // size it chose again
  function merge(base, mine, theirs) {
    var out = theirs.filter(function (i) { return !(find(base, i.handle) && !find(mine, i.handle)); })
      .map(function (i) { var m = find(mine, i.handle), b = find(base, i.handle); return m && b && m.variantId !== b.variantId ? m : i; });
    mine.forEach(function (i) { if (!find(base, i.handle) && !find(out, i.handle)) out.push(i); });
    return out.slice(-MAX_ITEMS);
  }
  function sendList() {
    if (!who) return;
    clearTimeout(syncTimer); syncTimer = 0;
    if (sending) return;                // one at a time: the next goes when this one is back
    sending = true;
    var list = read(), base = Number(syncMark().t) || 0;
    // keepalive: a send that leaves with the page still arrives
    fetch(syncUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ who: who, list: list, base: base }), keepalive: true })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, d: d || {} }; }, function () { return { status: r.status, d: {} }; }); })
      .then(function (res) {
        sending = false;
        var d = res.d, m = syncMark();
        if (res.status === 409 && d.conflict && conflicts < 3) {
          // written from another device since: theirs, with this device's changes on top
          conflicts++;
          var theirs = pieces(d.items);
          store(merge(pieces(m.b), read(), theirs));
          setSyncMark({ c: who.id, d: 1, t: Number(d.t) || 0, b: theirs });
          if (!root.hidden) render();
          sendList();
          return;
        }
        conflicts = 0;
        if (!d.ok) return;               // kept as changed: sent again on the next change or visit
        var now = read();
        setSyncMark({ c: who.id, d: sameList(now, list) ? 0 : 1, t: Number(d.t) || 0, b: list });
        if (!sameList(now, list)) sendList();     // changed while this was on its way
      })
      .catch(function () { sending = false; });   // offline: the mark keeps it waiting
  }
  function changed() {
    if (!who) return;
    var m = syncMark();
    setSyncMark({ c: who.id, d: 1, t: m.t || 0, b: m.b || [] });
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sendList, 700);
  }
  // a send still waiting as the page goes (a heart, then straight on to another page) leaves now
  function flush() { if (syncTimer) sendList(); }
  window.addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  (function sync() {
    var m = syncMark();
    if (!who) {
      // signed out on this device after being signed in: the list goes with the customer
      if (root.hasAttribute('data-wl-guest') && m.c) { store([]); setSyncMark({}); }
      return;
    }
    var el = root.querySelector('[data-wl-saved]'), acct = null;
    try { acct = el ? JSON.parse(el.textContent) : null; } catch (e) { acct = null; }
    var items = acct && Array.isArray(acct.items) ? pieces(acct.items) : null;
    var at = items ? Number(acct.t) || 0 : 0;
    var local = read(), next, base = at, b = items || [];
    if (m.c && m.c !== who.id) { local = []; m = {}; }          // another customer's list is not carried over
    if (m.c === who.id) {
      var mt = Number(m.t) || 0;
      if (items && at > mt) next = m.d ? merge(pieces(m.b), local, items) : items;   // written from elsewhere since
      else { next = local; base = mt; b = pieces(m.b); }        // this device's copy is the newest (the page's may be older)
    } else {
      next = (items || []).slice();                             // first time here signed in: the guest's pieces join
      local.forEach(function (i) { if (!find(next, i.handle)) next.push(i); });
      next = next.slice(-MAX_ITEMS);
    }
    if (!sameList(next, read())) store(next);
    var dirty = m.c === who.id && m.d ? true : !sameList(next, b);
    setSyncMark({ c: who.id, d: dirty ? 1 : 0, t: base, b: b });
    if (dirty) sendList();
  })();
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }

  function toggle(handle, variantId) {
    var list = read();
    var i = list.findIndex(function (x) { return x.handle === handle; });
    var added = i === -1;
    if (added) list.push({ handle: handle, variantId: variantId || null });
    else list.splice(i, 1);
    if (list.length > MAX_ITEMS) list = list.slice(-MAX_ITEMS);   // the oldest go, as the account keeps
    write(list);
    if (window.crTrack) crTrack(added ? 'wishlist_add' : 'wishlist_remove', { handle: handle });
    return added;
  }


  // The PDP heart is rendered once but the customer may switch colour afterwards, and Dawn
  // does not re-render this button — measured: the form input and URL move to the new variant
  // while data-wl-variant keeps the one Liquid rendered. So read the id from the form the
  // button actually sits in. Scoping to its OWN form matters: a page can hold several add-to-cart
  // forms (quick add), and the first one on the page is often a different product.
  // Card hearts sit in no form and correctly fall back to what Liquid rendered.
  function variantFor(btn) {
    var form = btn.closest('form[action*="/cart/add"]');
    var input = form && form.querySelector('input[name="id"]');
    if (input && input.value) return input.value;
    return btn.getAttribute('data-wl-variant');
  }
  /* ---------- header count + heart states ---------- */
  function paintCount() {
    var n = read().length;
    document.querySelectorAll('[data-wl-bubble]').forEach(function (el) {
      // Empty it rather than using [hidden]: .cart-count-bubble sets display:flex, which beats
      // the UA's [hidden]{display:none}, so a hidden badge still showed a literal "0".
      // Dawn's own .cart-count-bubble:empty{display:none} does the hiding for us.
      el.textContent = n === 0 ? '' : (n > 99 ? '99+' : String(n));
      el.hidden = n === 0;
    });
    // a control whose label stands for its contents (the header's person) says the count too
    document.querySelectorAll('[data-wl-open][data-wl-label]').forEach(function (a) {
      a.setAttribute('aria-label', a.getAttribute('data-wl-label') + (n ? ', ' + n + ' saved' : ''));
    });
  }
  function paintHearts() {
    document.querySelectorAll('[data-wl-toggle]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-wl-toggle'));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
      // The labelled PDP control states the action, so it has to flip with the state.
      var label = btn.querySelector('[data-wl-label]');
      if (label) label.textContent = on ? 'Saved to Wishlist' : 'Add to Wishlist';
    });
  }


  // Native share sheet on phones; clipboard everywhere else. Both end in visible feedback,
  // because a share control that appears to do nothing reads as broken.
  function doShare(btn) {
    var url = btn.getAttribute('data-share-url') || location.href;
    var title = btn.getAttribute('data-share-title') || document.title;
    var label = btn.querySelector('[data-share-label]');
    var say = function (text) {
      if (!label) return;
      var was = label.dataset.was || label.textContent;
      label.dataset.was = was;
      label.textContent = text;
      setTimeout(function () { label.textContent = was; }, 1800);
    };
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { say('Link copied'); })
        .catch(function () { say('Copy failed'); });
      return;
    }
    say('Copy failed');
  }
  /* ---------- open / close, mirroring cart-drawer ---------- */
  function markTab() {
    root.querySelectorAll('[data-wl-tab]').forEach(function (t) {
      var on = t.getAttribute('data-wl-tab') === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && tab !== 'rewards') body.setAttribute('aria-labelledby', t.id);
    });
    // the Rewards list is drawn by the page itself (snippets/kk-rewards-panel); the wishlist here
    body.hidden = tab === 'rewards';
    if (rewardsEl) rewardsEl.hidden = tab !== 'rewards';
    if (foot) foot.hidden = tab === 'rewards';
  }
  function open(which) {
    closing++;                                     // a close still sliding away stops here
    var ea = root.querySelector('[data-wl-ea]');
    if (ea) ea.hidden = true;                      // shown only when opened for early access
    if (root.hidden) lastFocus = document.activeElement;
    if (which) { tab = pick(which); markTab(); }
    root.hidden = false;
    // Force a style flush before the class flip: WebKit can coalesce rAFs across the
    // display:none boundary, and then the slide starts in its end state — a sudden pop.
    void root.offsetWidth;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.body.classList.add('overflow-hidden');
    // as the cart's lines do, the pieces rise into place as it opens (kk-wishlist.css)
    body.classList.add('is-rising');
    clearTimeout(body.__rise);
    body.__rise = setTimeout(function () { body.classList.remove('is-rising'); }, 1600);
    render();
    var x = root.querySelector('[data-wl-close]');
    if (x) setTimeout(function () { x.focus(); }, 60);
  }
  function close(after) {
    var token = ++closing;
    root.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    var panel = root.querySelector('.wl__panel');
    // Focus is restored AFTER the slide-out, with preventScroll — restoring it
    // immediately could scroll the page mid-animation, which reads as a stutter.
    var done = function () {
      if (token !== closing || root.classList.contains('is-open')) return;   // opened again meanwhile
      root.hidden = true;
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
      if (typeof after === 'function') after();
    };
    // Wait for the slide-out rather than guessing a timeout, so the hand-off to the cart
    // never overlaps and stutters. Fallback timer covers reduced-motion (no transitionend).
    var fired = false;
    panel.addEventListener('transitionend', function h(e) {
      if (e.propertyName !== 'transform' || fired) return;
      fired = true; panel.removeEventListener('transitionend', h); done();
    });
    setTimeout(function () { if (!fired) { fired = true; done(); } }, reduce ? 260 : 600);   // the slide is .5s
  }

  /* ---------- cart helpers ---------- */
  function cartState() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).catch(function () { return { items: [] }; });
  }
  function qtyInCart(cart, variantId) {
    var line = (cart.items || []).filter(function (i) { return String(i.id) === String(variantId); })[0];
    return line ? line.quantity : 0;
  }
  function openCartDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    return false;
  }
  // Ask the cart section to re-render so the drawer shows the new line immediately.
  function refreshCartSections() {
    var d = document.querySelector('cart-drawer');
    if (!d) return Promise.resolve();
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (s['cart-drawer']) {
          var html = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
          var fresh = html.querySelector('cart-drawer');
          var inner = d.querySelector('.drawer__inner');
          var freshInner = fresh && fresh.querySelector('.drawer__inner');
          if (inner && freshInner) inner.innerHTML = freshInner.innerHTML;
          if (fresh) d.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
        }
        if (s['cart-icon-bubble']) {
          var b = document.getElementById('cart-icon-bubble');
          var nb = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').getElementById('cart-icon-bubble');
          if (b && nb) b.innerHTML = nb.innerHTML;
        }
      }).catch(function () {});
  }

  /* ---------- render the drawer ---------- */
  function money(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }
  // Escapes for BOTH text and attribute context. The textContent/innerHTML trick that used to
  // live here leaves quotes untouched, which is fine in text but breaks out of an attribute —
  // and half the uses below are attributes.
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function emptyHtml() {
    var browse = root.getAttribute('data-wl-browse') || '/collections/all';
    return '<div class="wl__empty-wrap">' +
      '<p class="wl__empty-title">Your wishlist is empty</p>' +
      '<p class="wl__empty-sub">Save pieces you love so you can come back to them.</p>' +
      '<a class="wl__empty-cta" href="' + esc(browse) + '">Explore new arrivals</a>' +
      '</div>';
  }

  function skeletonHtml(n) {
    var row = '<div class="wl__skel" style="--i: 0;" aria-hidden="true">' +
      '<span class="wl__skel-thumb wl__shimmer"></span>' +
      '<span class="wl__skel-info">' +
        '<span class="wl__skel-line wl__skel-line--name wl__shimmer"></span>' +
        '<span class="wl__skel-line wl__skel-line--price wl__shimmer"></span>' +
        '<span class="wl__skel-btn wl__shimmer"></span>' +
      '</span></div>';
    return new Array(Math.min(n, 4) + 1).join(row);
  }

  // Product data cached for the life of the page: reopening the drawer paints
  // instantly from cache, then refetches quietly and re-renders only if anything
  // (price, stock, cart state) actually changed. First open shows skeleton rows.
  var productCache = {};
  var lastCart = { items: [] };
  var renderToken = 0;

  function buildHtml(rows, cart) {
    return rows.map(function (r, i) { return itemHtml(r.item, r.product, cart, i); }).join('');
  }

  function render() {
    var token = ++renderToken;
    if (foot) foot.hidden = tab === 'rewards';      // the reference's foot belongs to its wishlist, empty or not
    if (tab === 'rewards') return;
    var list = read();
    if (!list.length) { body.innerHTML = emptyHtml(); return; }

    var cached = list.every(function (i) { return productCache[i.handle]; });
    if (cached) {
      body.innerHTML = buildHtml(list.map(function (i) {
        return { item: i, product: productCache[i.handle] };
      }), lastCart);
    } else {
      body.innerHTML = skeletonHtml(list.length);
    }

    Promise.all([
      cartState(),
      Promise.all(list.map(function (item) {
        // A 404 means the product was deleted from the shop — only then is dropping the
        // item correct. A network failure MUST NOT be read as "gone": treating it that
        // way wiped the customer's whole wishlist the moment the drawer opened on a bad
        // connection. Offline items fall back to the cache, or to a retry state.
        return fetch(window.Shopify.routes.root + 'products/' + encodeURIComponent(item.handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (r.ok) return r.json().then(function (p) { return { item: item, product: p }; });
            return { item: item, gone: r.status === 404 || r.status === 410 };
          })
          .catch(function () { return { item: item }; });
      })),
    ]).then(function (res) {
      if (token !== renderToken) return;   // a newer render superseded this fetch
      lastCart = res[0];
      var keep = res[1].filter(function (x) { return !x.gone; });
      keep.forEach(function (x) { if (x.product) productCache[x.item.handle] = x.product; });
      if (keep.length !== list.length) {
        var gone = res[1].filter(function (x) { return x.gone; }).map(function (x) { return x.item.handle; });
        write(read().filter(function (i) { return gone.indexOf(i.handle) === -1; }));
      }
      var rows = keep
        .map(function (x) { return { item: x.item, product: x.product || productCache[x.item.handle] }; })
        .filter(function (x) { return x.product; });
      var html;
      if (rows.length) html = buildHtml(rows, lastCart);
      else if (keep.length) html = retryHtml();   // saved items exist, none reachable
      else html = emptyHtml();
      if (body.innerHTML !== html) body.innerHTML = html;
    });
  }

  function retryHtml() {
    return '<div class="wl__empty-wrap">' +
      '<p class="wl__empty-title">Can&#39;t load your wishlist</p>' +
      '<p class="wl__empty-sub">Check your connection and try again.</p>' +
      '<button type="button" class="wl__empty-cta" data-wl-retry>Try again</button>' +
      '</div>';
  }

  function pickVariant(product, savedId) {
    var vs = product.variants || [];
    var v = vs.filter(function (x) { return String(x.id) === String(savedId); })[0];
    return v || vs.filter(function (x) { return x.available; })[0] || vs[0];
  }

  // A variant named by what tells it apart: "46", not "Gold / 46" when every variant is Gold.
  function variantLabel(product, v) {
    var vs = product.variants || [], parts = [];
    ['option1', 'option2', 'option3'].forEach(function (k) {
      if (v[k] == null) return;
      var same = vs.every(function (x) { return x[k] === v[k]; });
      if (!same) parts.push(v[k]);
    });
    return parts.length ? parts.join(' / ') : v.title;
  }
  // The photograph as the cart's: it fades in over a frame that shimmers while it comes
  // (data-kk-frame / data-kk-fade: assets/kk-page).
  function picHtml(product, v) {
    var img = (v && v.featured_image && v.featured_image.src) || product.featured_image || '';
    var at = function (w) { return img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + '&quality=72'; };
    return '<a class="wl__pic" href="' + esc(product.url) + '" tabindex="-1" aria-hidden="true"' + (img ? ' data-kk-frame' : '') + '>' +
      (img ? '<img class="wl__thumb" src="' + esc(at(260)) + '" srcset="' + esc(at(120)) + ' 120w, ' + esc(at(200)) + ' 200w, ' + esc(at(260)) + ' 260w" sizes="104px" alt="" decoding="async" data-kk-fade>' : '') +
      '</a>';
  }
  function topHtml(product, v) {
    var sale = v.compare_at_price && v.compare_at_price > v.price;
    return '<div class="wl__top">' +
      '<a class="wl__name" href="' + esc(product.url) + '">' + esc(product.title) + '</a>' +
      '<span class="wl__price">' + money(v.price) + (sale ? '<s class="wl__was">' + money(v.compare_at_price) + '</s>' : '') + '</span>' +
      '</div>';
  }

  // Signed in, what the piece earns (data-wl-earn: the tier's rate|any double days), counted
  // as the product page counts it: 1 point for every ₹20, at the tier's rate, then the days.
  var EARN = (root.getAttribute('data-wl-earn') || '').split('|');
  function earnHtml(v) {
    if (EARN.length !== 2) return '';
    var n = Math.floor(Math.floor(v.price / 2000) * (Number(EARN[0]) || 1)) * (Number(EARN[1]) || 1);
    return n > 0 ? '<p class="wl__earn">Earn ' + n.toLocaleString('en-IN') + ' points</p>' : '';
  }

  // A saved piece: its size can be changed here before it goes to the bag, as on the reference —
  // in its small box ("M ▾"), over which the phone's own list opens (the select itself, unseen,
  // at 16px so iOS does not zoom in on it).
  function itemHtml(item, product, cart, i) {
    var v = pickVariant(product, item.variantId);
    if (!v) return '';
    var many = (product.variants || []).length > 1;
    var opt = '';
    if (many) {
      opt = '<label class="wl__opt">' +
        '<span class="wl__opt-face" aria-hidden="true">' + esc(variantLabel(product, v)) + '<i>▾</i></span>' +
        '<span class="visually-hidden">Choose for ' + esc(product.title) + '</span>' +
        '<select data-wl-pick="' + esc(item.handle) + '">' +
        product.variants.map(function (x) {
          return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(variantLabel(product, x)) + (x.available ? '' : ' (sold out)') + '</option>';
        }).join('') +
        '</select></label>';
    }
    var action = !v.available
      ? '<span class="wl__sold">Sold out</span>'
      : qtyInCart(cart, v.id)
        ? '<span class="wl__in">In your bag</span>'
        : '<button type="button" class="wl__move" data-wl-add="' + v.id + '" data-wl-move="' + esc(item.handle) + '">Move to bag</button>';
    return '' +
      '<div class="wl__item" style="--i: ' + (i || 0) + ';" data-wl-row="' + esc(item.handle) + '">' +
        picHtml(product, v) +
        '<div class="wl__info">' + topHtml(product, v) +
          '<div class="wl__mid">' + opt + earnHtml(v) + '</div>' +
          '<div class="wl__bottom">' + action +
            '<button type="button" class="wl__remove" data-wl-drop="' + esc(item.handle) + '" aria-label="Remove ' + esc(product.title) + ' from wishlist">' +
              '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" fill="none"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  /* ---------- add to bag ---------- */
  function addToBag(btn) {
    var id = btn.getAttribute('data-wl-add');
    btn.disabled = true;
    var original = btn.textContent;
    (window.kkBusy || function () {})(btn, true);       // the shop's waiting look (assets/kk-loading.css)
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          // Shopify refuses when stock runs out and explains why — show its words, not ours.
          var msg = (res.data && (res.data.description || res.data.message)) || 'Could not add this right now.';
          (window.kkBusy || function () {})(btn, false);
          // held for members (snippets/kk-early-guard opens Rewards): the piece itself is fine
          var early = res.data && res.data.message === 'Early access';
          btn.textContent = early ? original : 'Max in your bag';
          btn.disabled = !early;
          var old = btn.parentElement.parentElement.querySelector('.wl__note');
          if (old) old.remove();
          var note = document.createElement('p');
          note.className = 'wl__note';
          note.textContent = msg;
          btn.parentElement.insertAdjacentElement('afterend', note);
          return;
        }
        if (window.crTrack) crTrack('wishlist_add_to_cart', { variantId: id });
        var moving = btn.getAttribute('data-wl-move');
        if (moving) write(read().filter(function (i) { return i.handle !== moving; }));
        announce(moving ? 'Moved to your bag' : 'Added to your bag');
        if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist', productVariantId: id, cartData: res.data });
        }
        return refreshCartSections().then(function () {
          // Close the wishlist FIRST, then open the cart, so the two panels never
          // occupy the same space mid-animation.
          close(function () { openCartDrawer(); });
        });
      })
      .catch(function () { (window.kkBusy || function () {})(btn, false); btn.disabled = false; btn.textContent = original; });
  }

  /* ---------- tabs ---------- */
  function setTab(name, focus) {
    tab = pick(name);
    markTab();
    if (focus) { var t = root.querySelector('[data-wl-tab][aria-selected="true"]'); if (t) t.focus(); }
    body.scrollTop = 0;
    render();
  }
  root.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('[data-wl-tab]');
    if (!t || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    e.preventDefault();
    var order = Array.prototype.map.call(root.querySelectorAll('[data-wl-tab]'), function (t) { return t.getAttribute('data-wl-tab'); });
    var at = order.indexOf(tab);
    setTab(order[(at + (e.key === 'ArrowRight' ? 1 : order.length - 1)) % order.length], true);
  });

  // The header's heart nods when the count changes.
  function nod() {
    document.querySelectorAll('[data-wl-open]').forEach(function (el) {
      el.classList.remove('is-nod'); void el.offsetWidth; el.classList.add('is-nod');
      setTimeout(function () { el.classList.remove('is-nod'); }, 500);
    });
  }

  /* ---------- one delegated listener for the whole feature ---------- */
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-wl-toggle]');
    if (heart) {
      e.preventDefault();
      var added = toggle(heart.getAttribute('data-wl-toggle'), variantFor(heart));
      heart.classList.remove('is-pop', 'is-unpop', 'is-beat'); void heart.offsetWidth;
      heart.classList.add(added ? 'is-pop' : 'is-unpop');
      setTimeout(function () { heart.classList.remove('is-pop', 'is-unpop'); }, 600);
      nod();
      var isOpen = !root.hidden && root.classList.contains('is-open');
      if (isOpen) render();
      // The product page's heart, once filled, opens the list, as the reference's does —
      // unless it is tapped again first.
      clearTimeout(autoOpen);
      var saved = heart.getAttribute('data-wl-toggle');
      if (!isOpen && added && heart.classList.contains('kkp-heart')) {
        autoOpen = setTimeout(function () { if (has(saved) && root.hidden) open('saved'); }, reduce ? 0 : 450);
      }
      return;
    }
    var share = e.target.closest('[data-pdp-share]');
    if (share) { e.preventDefault(); doShare(share); return; }
    if (e.target.closest('[data-wl-open]')) { e.preventDefault(); open('saved'); return; }
    if (e.target.closest('[data-wl-rewards-open]')) { e.preventDefault(); open(rewardsEl ? 'rewards' : 'saved'); return; }
    if (e.target.closest('[data-wl-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-wl-retry]')) { render(); return; }
    var tabBtn = e.target.closest('[data-wl-tab]');
    if (tabBtn) { setTab(tabBtn.getAttribute('data-wl-tab')); return; }
    var drop = e.target.closest('[data-wl-drop]');
    if (drop) {
      var handle = drop.getAttribute('data-wl-drop');
      var list = read().filter(function (i) { return i.handle !== handle; });
      write(list);
      var row = drop.closest('[data-wl-row]');
      if (row) { row.classList.add('is-leaving'); setTimeout(render, reduce ? 0 : 300); }
      announce('Removed from your wishlist');
      return;
    }
    var add = e.target.closest('[data-wl-add]');
    if (add && !add.disabled) { addToBag(add); }
  });

  // a saved piece's size changed in the list: it is that size that goes to the bag
  document.addEventListener('change', function (e) {
    var pick = e.target.closest && e.target.closest('[data-wl-pick]');
    if (!pick) return;
    var handle = pick.getAttribute('data-wl-pick');
    write(read().map(function (i) { return i.handle === handle ? { handle: i.handle, variantId: Number(pick.value) } : i; }));
    render();
    var again = Array.prototype.filter.call(body.querySelectorAll('[data-wl-pick]'), function (el) { return el.getAttribute('data-wl-pick') === handle; })[0];
    if (again) again.focus({ preventScroll: true });
  });

  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !root.classList.contains('is-open')) return;
    var f = Array.prototype.filter.call(
      root.querySelectorAll('.wl__panel button, .wl__panel a[href], .wl__panel select, .wl__panel [tabindex]'),
      function (el) { return el.getAttribute('tabindex') !== '-1' && !el.disabled && el.getClientRects().length; }
    );
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // This snippet renders BEFORE the header and any product sections, so at execution time
  // the count bubble and the hearts do not exist yet. Painting immediately silently no-ops
  // and the page loads showing an empty wishlist. Wait for the document instead.
  function paintAll() { paintCount(); paintHearts(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintAll);
  else paintAll();
  // Sections rendered later (quick view, section re-renders) get their hearts painted too.
  window.addEventListener('load', paintAll);

  // "You may also like" is a <product-recommendations> element that fetches its markup after
  // the page has loaded, so its hearts appear long after the paints above have run and would
  // sit permanently unfilled even for saved items. Watch for hearts arriving and paint those.
  var repaint = null;
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && (n.matches('[data-wl-toggle]') || n.querySelector('[data-wl-toggle]'))) {
          clearTimeout(repaint);
          repaint = setTimeout(paintHearts, 40);   // one paint per burst, not per node
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------- rewards: the welcome points, the first time a customer is signed in ----------
     The id is signed by the page (snippets/kk-rewards-panel); the Worker gives them once. */
  (function join() {
    var data = rewardsEl && rewardsEl.getAttribute('data-wl-join');
    var url = rewardsEl && rewardsEl.getAttribute('data-wl-join-url');
    if (!data || !url) return;
    // asked once per customer per visit; forgotten again unless the points came
    var flag = 'kk_rw_join:' + ((data.match(/"id":"(\d+)"/) || [])[1] || '');
    function forget() { try { sessionStorage.removeItem(flag); } catch (e) {} }
    try { if (sessionStorage.getItem(flag) === '1') return; sessionStorage.setItem(flag, '1'); } catch (e) {}
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: data })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.ok) { forget(); return; }
        var n = Math.max(0, Number(d.points) || 0), into = n % 100;
        var pts = rewardsEl.querySelector('[data-wl-points]'), bar = rewardsEl.querySelector('[data-wl-bar]'), next = rewardsEl.querySelector('[data-wl-next]');
        if (pts) pts.textContent = String(n);
        if (bar) bar.style.width = into + '%';
        if (next) next.textContent = (100 - into) + ' more point' + (100 - into === 1 ? '' : 's') + ' to your next ₹100 off · about ₹' + ((100 - into) * 20).toLocaleString('en-IN') + ' of shopping';
        announce('50 welcome points are yours');
      })
      .catch(forget);
  })();

  /* ---------- rewards, signed out: what it gives, one at a time, as the reference's ----------
     On by itself every few seconds, only while the tab is in sight and nothing in it is
     pointed at or focused (never for reduced motion); by the dots; by a swipe. */
  (function slides() {
    var wrap = rewardsEl && rewardsEl.querySelector('[data-wl-rw-slides]');
    if (!wrap) return;
    var all = wrap.querySelectorAll('[data-wl-rw-slide]'), dots = wrap.querySelectorAll('[data-wl-rw-dot]');
    var at = 0, last = Date.now(), x0 = null, y0 = 0;
    function show(i) {
      at = (i + all.length) % all.length;
      last = Date.now();
      all.forEach(function (s, n) { s.classList.toggle('is-on', n === at); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === at); d.setAttribute('aria-pressed', n === at ? 'true' : 'false'); });
    }
    // a touch screen keeps :hover where the last tap was, so only a real pointer's hover holds it
    var hovers = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    function held() { return (hovers && wrap.matches(':hover')) || wrap.contains(document.activeElement); }
    if (!reduce && all.length > 1) {
      setInterval(function () {
        if (root.hidden || rewardsEl.hidden || document.hidden || held()) { last = Date.now(); return; }
        if (Date.now() - last >= 4500) show(at + 1);
      }, 500);
    }
    wrap.addEventListener('click', function (e) {
      var d = e.target.closest('[data-wl-rw-dot]');
      if (d) show(Number(d.getAttribute('data-wl-rw-dot')) || 0);
    });
    wrap.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(at + (dx < 0 ? 1 : -1));
    }, { passive: true });
  })();

  // early access (snippets/kk-early-guard): Rewards opens with why the piece is not theirs yet,
  // in place of a note — the reference's sign-in drawer
  function openEarly(opens) {
    if (!rewardsEl) return false;
    open('rewards');
    var ea = root.querySelector('[data-wl-ea]');
    var when = ea && ea.querySelector('[data-wl-ea-when]');
    if (when && opens) when.textContent = opens;
    if (ea) ea.hidden = false;
    announce('Early access: for Silver members and above until ' + (opens || 'it opens'));
    return true;
  }
  window.__kkWishlist = { open: open, openEarly: openEarly, close: close, refresh: paintAll, count: function () { return read().length; } };
})();
